import { ActionReducerMap } from '@ngrx/store';

import { configureCleanReducer, configureSyncReducer, TileAction, TileId } from '@contact/upgrade';

/**
 * Name store feature
 */
export const featureName = 'wallboard-config';

/**
 * WallboardConfig state interface
 */
export interface WallboardConfigState {}

/**
 * Initial WallboardConfig state
 */
export const initialState: WallboardConfigState = {};

/**
 * WallboardConfig reducers map
 */
export const reducers: ActionReducerMap<WallboardConfigState> = {};

const cleanReducer = configureCleanReducer(featureName, {
  initialState,
  keys: [],
  cleanPredicate: action => action.type === TileAction.Reset.type && action.tileId === TileId.WALLBOARD_CONFIG,
});
const syncReducer = configureSyncReducer(featureName, []);

/**
 * Core meta reducers array
 */
export const metaReducers = [cleanReducer, syncReducer];
